var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EChart',_vm._b({attrs:{"theme":"ovilia-green","auto-resize":_vm.autoResize},on:{"click":function (params) { return _vm.$emit('click', params); }}},'EChart',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }